module.exports = __webpack_public_path__ + "static/media/custom-branding-icon.41365ceb.svg";